import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/18/thumb-landscape.jpg"

const Post18 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          多くの女性が憧れるCELINE／セリーヌのバッグ。<br></br>世界中のセレブや有名人が愛用し、おしゃれな人はたいてい持っている… そんなイメージではないでしょうか？セリーヌは飾りすぎないオシャレが楽しめるのが魅力。その人だけの魅力を引き出してくれる、そんなブランドです。<br></br>そこで今回は、シンプルかつエレガントに大人の女性を彩ってくれる「セリーヌ」の人気バッグ10選をご紹介します！
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>ラゲージ</h2>
          <figure>
            <StaticImage src="../../images/posts/18/1.jpg" alt="" />
          </figure>
          <p>CELINEといえば「ラゲージ」！ご存知、セリーヌのアイコンバッグです。<br></br>シンプルでミニマルながらも一度見たら忘れないユニークなデザイン。持つだけで、コーデを洗練されたスタイルに変えてくれます。<br></br>ナノ、マイクロ、ミニショッパー、ファントムの４サイズ。幅広いサイズ展開でライフスタイルに寄り添ってくれるのも魅力です。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/2.jpg" alt="" />
            <span className="text-center">ナノショッパー/20x19x10cm</span>
          </figure>
          <figure className="img-small">
              <StaticImage src="../../images/posts/18/3.jpg" alt="" />
              <span className="text-center">マイクロショッパー/25x25x13cm</span>
          </figure>        
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/4.jpg" alt="" />
            <span className="text-center">ミニショッパー/29x28x15cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/5.jpg" alt="" />
            <span className="text-center">ファントム/30x28x24cm</span>
          </figure>          
        </div>
        <figure>
          <StaticImage src="../../images/posts/18/6.jpg" alt="" />
        </figure>
        <p>ファントム以外は、写真では違いがわかりにくいので、大きさを比較しちゃいます！</p>
        <figure>
          <StaticImage src="../../images/posts/18/7.jpg" alt="" />
        </figure>
        <p>まず、一番小さいナノはストラップ付き。<br></br>お休みの日におでかけにちょうどいいサイズ感です。クロスボディでも、トップハンドルでも持てるのでコーデの幅も広がりそう。</p>
        <figure>
          <StaticImage src="../../images/posts/18/8.jpg" alt="" />
        </figure>
        <p>こちらはマイクロ。<br></br>ラゲージといえば、このサイズを思い浮かべる方も多いと思います。A4サイズのノートがスッポリ収まる便利な大きさです。</p>
        <figure>
          <StaticImage src="../../images/posts/18/9.jpg" alt="" />
        </figure>
        <p>そして、最後はミニ。<br></br>13インチのMac Bookも余裕で入っちゃうのに「ミニ」なのです！お仕事に使える頼もしいサイズ感。荷物が増えがちな方も安心ですね。</p>
        <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
          セリーヌのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>カバファントム</h2>
          <figure>
            <StaticImage src="../../images/posts/18/10.jpg" alt="" />
          </figure>          
          <p>クタッとしたフォルムからこなれ感が漂うカバファントム。<br></br>ガバっと大きく開き、バッグの中のスペースも広めです。柔らかいレザーなので重いものを持ち運ぶのはオススメできませんが、季節の変わり目に重宝する大判ストールなど嵩張るものもスッポリ収まります。カラー展開も豊富です。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/18/11.jpg" alt="" />
            <span className="text-center">27x34x19cm</span>
        </figure>                                 
        <div className="img-two-cloumn">     
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/12.jpg" alt="" />
            <span className="text-center">27x29x17cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/13.jpg" alt="" />
            <span className="text-center">30～55x37x21cm</span>
          </figure>          
        </div>
        <div className="text-max-width">
          <h2>トリフォルド</h2>
          <figure>
            <StaticImage src="../../images/posts/18/14.jpg" alt="" />
          </figure>          
          <p>肩にかけても身体に沿う形状で、通勤バッグにピッタリ。サイズはミディアム、スモールとチェーンの取り外しができるクラッチの3種類です。<br></br>1番の特徴は3つのコンパートメント構造。中央部分にはジップも付いているので、お財布などの貴重品も安心して収納できます。</p>
        </div>
        <figure>
            <StaticImage src="../../images/posts/18/14-2.png" alt="" />
        </figure>
        <figure className="img-small">
              <StaticImage src="../../images/posts/18/15.jpg" alt="" />
              <span className="text-center">31x22x13cm</span>
          </figure>        
        <div className="img-two-cloumn">
          <figure className="img-small">
              <StaticImage src="../../images/posts/18/16.jpg" alt="" />
              <span className="text-center">36x25x11cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/17.jpg" alt="" />
            <span className="text-center">36x24x11cm</span>
          </figure>         
        </div>               
        <div className="text-max-width">
          <h2>ベルトバッグ</h2>
          <figure>
            <StaticImage src="../../images/posts/18/18.jpg" alt="" />
          </figure>          
            <p>上品でシャープなフォルムに長く伸びた2本のレザーベルトがポイントのベルトバッグ。<br></br>サイズ展開はピコ、ナノ、マイクロ、ミニの4種類です。1番大きなミニでも横幅は28cmほどしかありません。通勤バッグで使うならコレくらいの大きさが使い勝手が良さそうです。</p>
        </div>
        <figure>
          <StaticImage src="../../images/posts/18/19.jpg" alt="" />
          <span className="text-center">なにかと便利な内側のポケットが嬉しい！</span>
        </figure>
        <figure className="img-small">
            <StaticImage src="../../images/posts/18/20.jpg" alt="" />
            <span className="text-center">ベルトバッグミニ/28x23x17cm</span>
        </figure>                
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/21.jpg" alt="" />
            <span className="text-center">ベルトバッグマイクロ/24x20x13cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/22.jpg" alt="" />
            <span className="text-center">ベルトバッグマイクロ/24x20x13cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ホリゾンタルカバ</h2>
          <figure>
            <StaticImage src="../../images/posts/18/23.jpg" alt="" />
          </figure>          
            <p>「カバ」シリーズは前クリエイティブディレクターのフィービーの名作。<br></br>そのDNAを受け継ぎ、現クリエイティブディレクターのエディがブラッシュアップさせたのがホリゾンタルカバです。</p>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/24.jpg" alt="" />
            <span className="text-center">34x35x19cm</span>
          </figure>            
        </div>
        <div className="text-max-width">
          <h2>クラスプ</h2>
          <figure>
            <StaticImage src="../../images/posts/18/25.jpg" alt="" />
          </figure>          
            <p>艶のあるスムースカーフに端正なフォルム。大人の女性に持ってほしい上品なバッグです。<br></br>クラスプは3タイプ展開。ワンハンドル、ショルダー、ミニショルダーから着こなしのイメージで選びましょう。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/18/26.jpg" alt="" />
            <span className="text-center">カバクラスプ/31x33x12cm</span>
        </figure>                
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/27.jpg" alt="" />
            <span className="text-center">ミニクラスプ/22x18x3cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/28.jpg" alt="" />
            <span className="text-center">ミニクラスプ/22x18x3cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>クラシックボックス</h2>
          <figure>
            <StaticImage src="../../images/posts/18/29.jpg" alt="" />
          </figure>          
          <p>一切の無駄を省いたシンプルなデザイン。<br></br>デイリーはもちろん、オンオフ問わず使える優れものです。うっとりするほど上質なレザーの質感に、気分が高揚してしまうはず。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/18/30.jpg" alt="" />
            <span className="text-center">23x20x6cm</span>
        </figure>                
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/31.jpg" alt="" />
            <span className="text-center">16x13x8cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/32.jpg" alt="" />
            <span className="text-center">16x13x8cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>トロッター</h2>
          <figure>
            <StaticImage src="../../images/posts/18/33.jpg" alt="" />
          </figure>          
          <p>コロンとした見た目がキュートなトロッター。<br></br>フラップ部分のメタルがエレガントで、ドレスアップしたイブニングシーンやナイトシーンにもオススメです！これ一つで、フェミニンでモダンなスタイルに早変わり。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/18/34.jpg" alt="" />
            <span className="text-center">19x15x5cm</span>
        </figure>                
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/35.jpg" alt="" />
            <span className="text-center">18x17x5cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/36.jpg" alt="" />
            <span className="text-center">22x21x6cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>トラペーズ</h2>
          <figure>
            <StaticImage src="../../images/posts/18/37.jpg" alt="" />
          </figure>          
          <p>逆台形の個性的なデザインが特徴で、持ち手のワンハンドルが都会的な印象に。サイドを畳むとよりシンプルなハンドバッグに変身するのも魅力です。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/18/38.jpg" alt="" />
            <span className="text-center">30x22x17cm</span>
        </figure>                
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/39.jpg" alt="" />
            <span className="text-center">27x21x16cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/40.jpg" alt="" />
            <span className="text-center">29x23x17cm</span>
          </figure>
        </div>
        <div className="text-max-width">
          <h2>トリオ</h2>
          <figure>
            <StaticImage src="../../images/posts/18/41.jpg" alt="" />
          </figure>          
          <p>名前の通り３つのポーチが一体となったデザインが特徴の「トリオ」。<br></br>スナップボタンで取り外しができ、３つのポーチを２つにするなどのアレンジも可能。様々な組み合わせができるミニマル派の強い味方です。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/18/42.jpg" alt="" />
            <span className="text-center">21x14x3cm</span>
        </figure>                
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/43.jpg" alt="" />
            <span className="text-center">28x20x5cm</span>
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/18/44.jpg" alt="" />
            <span className="text-center">25x18x2cm</span>
          </figure>
        </div>                        
        <div className="text-two-cloumn">
          <h2>流行に左右されない<br className="pc"></br>CELINE（セリーヌ）</h2>
          <p>「CELINE（セリーヌ）のミニマルで洗練されたデザインは､普段の生活に寄り添い､持つ人に光を当て輝かせてくれます。<br></br>〝素敵な女性はセリーヌを持っている〟そう断言してもいいくらい、大人の女性たちに支持されているブランドです。シンプルでスタイリッシュだからこそ、いつ、どこで、誰といたとしても持つことができるのです。これが世界中のファッショニスタたちに長く愛されている理由かもしれません。<br></br>まずはセリーヌのバッグをいつものコーデに合わせてみましょう！きっと普段と違うコーデができあがるはずです。</p>
        </div>
        <Link to="https://laxus.co/app/pc/bags/celine" className="view-all-button">
          セリーヌのバッグを見る
        </Link>
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post18

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 18}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
